import { Model, ObservableList, ViewModel } from '@neos/core'

/**
 * Represents CustomSubUIViewEntityViewParameterUI.
 */
export default class CustomSubUIViewEntityViewParameterUI extends Model {
  /**
   * Initializes a new instance of the CustomSubUIViewEntityViewParameterUI class.
   * 
   * @param item Item.
   * @param viewModel ViewModel.
   */
  constructor(item?: Record<string, unknown>, viewModel?: ViewModel<CustomSubUIViewEntityViewParameterUI>) {
    super({
      $new: !item,
      id: 0,
      ...item
    }, viewModel)
  }

  /**
   * Gets or sets Identifier.
   */
  id: number

  /**
   * Gets or sets Name.
   */
  name?: string | null

  /**
   * Gets or sets Value.
   */
  value?: string | null

  /**
   * Gets or sets $keyProperties.
   */
  static $keyProperties = new Set(['id'])
}